import React from "react";
import styled from "styled-components";

export default function ScoreRuleCustomTextInput(props) {
  const { index, value, setValue, placeholder, isEdit } = props;

	function handleChange(e) {
    setValue(e.target.value, index);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

  return (
    <InputView border={isEdit ? '2px dashed #909090' : '2px solid #909090'}>
      <Input
        placeholder={placeholder}
        value={value}
        type='text'
        disabled={!isEdit}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </InputView>
  )
}

const InputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px 10px;

  width: calc(100% - 26px);

  border: ${props => props.border};
  border-radius: 10px;
  background-color: #2F2F32;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 17px;

	width: 100%;
	height: 17px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
  text-align: center;
	color: #FFFFFF;

  border: none;
  background-color: #2F2F32;

	::placeholder {
		color: #6A6A6C;
	}
  
  transition: all 0.3s ease-in-out;
`;